import { qsa } from "@fluorescent/dom";
import {
  FadeUpReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  fadeUp: ".animation-fade-up-reveal:not(.animation-initialized)",
};

export default node => {
  let observer = null;
  let fadeUpItems = null;
  let reveals = [];

  _initializeItems(_initObserver);

  function _initializeItems(cb) {
    if (shouldAnimate(node)) {
      fadeUpItems = qsa(selectors.fadeUp, node);
      reveals = [];
      // Initialize animations and intersection observer
      fadeUpItems.forEach(item => {
        reveals.push(new FadeUpReveal(item, { yStart: "40px" }));
      });

      if (typeof cb === "function") {
        cb();
      }
    }
  }

  function _initObserver() {
    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let delay = 0;
    reveals.forEach(reveal => {
      reveal.play(delay);
      delay += window.theme.animation.delay;
    });
  }

  function updateItems() {
    _initializeItems(isVisible);
  }

  return {
    updateItems,
    destroy() {
      observer?.destroy();
    },
  };
};
